import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import ModeCommentTwoToneIcon from '@mui/icons-material/ModeCommentTwoTone';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const KanbanCardCommentActions = (props) => {
    const { t } = useTranslation();
    return (
        <>
            <Box style={{ display: 'flex', alignItems: 'center', width: '100%', flexDirection: 'row' }}>
                <div style={{ display: 'flex', width: '100%', flexDirection: 'column', justifyItems: 'space-between' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Tooltip title={t("kanban.comments.toggleCommentSection")}>
                            <IconButton
                                className={"color color-medium-" + (props.numberOfComments == 0 ? "gray" : "blue")}
                                disabled={props.numberOfComments == 0}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    props.toggleExpanded()
                                }}
                            >
                                <ModeCommentTwoToneIcon style={{ marginRight: '2px' }} />
                            </IconButton>
                        </Tooltip>
                        <div className={"color color-medium-" + (props.numberOfComments == 0 ? "gray" : "blue")}>
                            {props.numberOfComments}
                        </div>
                    </div>
                </div>
                <Tooltip title={t("kanban.comments.addComment")}>
                    <IconButton
                        onClick={(e) => {
                            e.stopPropagation();
                            props.openCommentDialog(props.cardId, props.columnId);
                        }}
                    >
                        <AddTwoToneIcon className="color color-medium-blue" />
                    </IconButton>
                </Tooltip>
            </Box>
        </>
    );
}

KanbanCardCommentActions.propTypes = {
    numberOfComments: PropTypes.number,
    toggleExpanded: PropTypes.func,
    cardId: PropTypes.string,
    columnId: PropTypes.number,
    openCommentDialog: PropTypes.func
};

export default KanbanCardCommentActions;